<template>
  <div>
    <list
      ref="refJobScheduleList"
      sort-by="PuestoHorarioId"
      :refetch-records="fetchJobSchedules"
      refetch-records-name="puestoHorarios"
      :actions="actions"
      key-field="puestoHorarioId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteJobSchedule"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refJobScheduleList = ref(null)
    /* Services */
    const {
      fetchJobSchedules,
      deleteJobSchedule,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.jobSchedule.columns.job'),
        key: 'puesto.nombre',
      },
      {
        label: i18n.t('humanResources.jobSchedule.columns.schedule'),
        key: 'horario.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'PuestoHorario',
        routeName: 'apps-human-resources-job-schedule-edit',
        params: ['puestoHorarioId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'PuestoHorario',
        params: ['puestoHorarioId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-job-schedule-add',
        label: i18n.t('Routes.JobScheduleAdd'),
        aclAction: 'create',
        aclResource: 'PuestoHorario',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refJobScheduleList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchJobSchedules,
      deleteJobSchedule,
    }
  },
}
</script>
